<div class="tl-wrap" [ngStyle]="themeVars">

	<!-- Floating icon badge -->
	<div class="tl-icon-badge">
		<i class="material-icons">leaderboard</i>
	</div>

	<!-- Header -->
	<div class="tl-header">
		<div class="tl-title-group">
			<span class="tl-title">{{ limited ? 'Top 3 Reps' : 'Sales Team' }}</span>
			<span class="tl-subtitle" *ngIf="datefrom && dateto">
				{{ datefrom | date:'MMM d' }} – {{ dateto | date:'MMM d, y' }}
			</span>
		</div>
		<div class="tl-actions">
			<button class="tl-preset-toggle" [class.tl-preset-toggle--active]="showPresets"
					(click)="showPresets = !showPresets" title="Change period">
				<i class="material-icons">date_range</i>
				{{ activePreset }}
				<i class="material-icons tl-chevron">expand_more</i>
			</button>
			<button class="tl-icon-btn" [class.tl-icon-btn--active]="showFilters || filterCount > 0"
					(click)="showFilters = !showFilters" title="Brand / category filters">
				<i class="material-icons">tune</i>
				<span class="tl-filter-count" *ngIf="filterCount > 0">{{ filterCount }}</span>
			</button>
			<button class="tl-icon-btn" [class.tl-icon-btn--active]="view === 'table'"
					(click)="view = view === 'bars' ? 'table' : 'bars'"
					[title]="view === 'table' ? 'Show bars' : 'Show table'">
				<i class="material-icons">{{ view === 'table' ? 'bar_chart' : 'table_rows' }}</i>
			</button>
			<button class="tl-icon-btn" (click)="exportXls()" [disabled]="loading || exporting || !reps.length" title="Export to Excel">
				<i class="material-icons">grid_on</i>
			</button>
			<button class="tl-icon-btn" (click)="exportPdf()" [disabled]="loading || exporting || !reps.length" title="Export to PDF">
				<i class="material-icons">picture_as_pdf</i>
			</button>
			<button class="tl-icon-btn" (click)="refresh()" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
		</div>
	</div>

	<!-- Period presets -->
	<div class="tl-presets" *ngIf="showPresets">
		<button *ngFor="let p of presets"
				class="tl-preset-btn" [class.tl-preset-btn--active]="activePreset === p.label"
				(click)="selectPreset(p)">{{ p.label }}</button>

		<div class="tl-custom-range" *ngIf="activePreset === 'Custom'">
			<input type="date" class="tl-date-input" [(ngModel)]="customFrom" [max]="customTo || null">
			<span class="tl-custom-sep">to</span>
			<input type="date" class="tl-date-input" [(ngModel)]="customTo" [min]="customFrom || null">
			<button class="tl-apply-btn" (click)="applyCustom()" [disabled]="loading || !customFrom || !customTo">
				<i class="material-icons">play_arrow</i> Go
			</button>
		</div>
	</div>

	<!-- Brand / category filters -->
	<div class="tl-filters" *ngIf="showFilters">
		<mat-form-field appearance="outline" class="tl-field">
			<mat-label>Brand</mat-label>
			<mat-select [formControl]="brands" multiple appSelectAll>
				<mat-option *ngFor="let b of brandList" [value]="b.manufacturer_id">{{ b.name }}</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="tl-field">
			<mat-label>Category{{ brandsNarrowed ? ' (brand)' : '' }}</mat-label>
			<mat-select [formControl]="categories" multiple appSelectAll>
				<mat-option *ngFor="let c of categoryList" [value]="c.categoryid">{{ c.categorydescription }}</mat-option>
			</mat-select>
			<mat-hint *ngIf="brandsNarrowed">{{ categoryList.length }} carried by the selected brand(s)</mat-hint>
		</mat-form-field>

		<!-- Top-3-restricted reps get no rep picker; the server ignores it for them too. -->
		<mat-form-field *ngIf="!limited" appearance="outline" class="tl-field">
			<mat-label>Salespeople</mat-label>
			<mat-select [formControl]="salespeople" multiple appSelectAll>
				<mat-option *ngFor="let r of repList" [value]="r.salesmancode">{{ r.salesmanname }}</mat-option>
			</mat-select>
			<mat-hint *ngIf="salespeople.value?.length">Totals and bar shares cover the selected reps only</mat-hint>
		</mat-form-field>

		<div class="tl-filter-actions">
			<button class="tl-apply-btn" (click)="applyFilters()" [disabled]="loading">
				<i class="material-icons">play_arrow</i> Apply
			</button>
			<button class="tl-clear-btn" (click)="clearFilters()" [disabled]="loading || filterCount === 0">
				<i class="material-icons">clear</i> Clear
			</button>
		</div>
	</div>

	<!-- Filtered-scope note: counts below are for the filtered lines only -->
	<div class="tl-filter-note" *ngIf="filtered && !loading">
		<i class="material-icons">filter_alt</i>
		<span>Ranking, invoice and customer counts cover the selected brand/category lines only. YoY compares the same slice.</span>
	</div>

	<!-- Stats strip — Total/Active only make sense on the full-team view -->
	<div class="tl-stats" *ngIf="!loading && reps.length">
		<div class="tl-stat" *ngIf="!limited">
			<span class="tl-stat-val">{{ total | currency:'CAD':'symbol-narrow':'1.0-0' }}</span>
			<span class="tl-stat-lbl">Total Sales</span>
		</div>
		<div class="tl-stat" *ngIf="!limited">
			<span class="tl-stat-val">{{ reps.length }}</span>
			<span class="tl-stat-lbl">Reps Active</span>
		</div>
		<div class="tl-stat tl-stat--wide">
			<span class="tl-stat-val" [title]="reps[0]?.salesmanname">{{ reps[0]?.salesmanname }}</span>
			<span class="tl-stat-lbl">Top Rep</span>
		</div>
		<div class="tl-stat">
			<span class="tl-stat-val" [class.tl-up]="reps[0]?.yoy >= 0" [class.tl-dn]="reps[0]?.yoy < 0">
				{{ formatPct(reps[0]?.yoy ?? null) }}
			</span>
			<span class="tl-stat-lbl">Top YoY</span>
		</div>
	</div>

	<!-- Loading -->
	<div class="tl-loading" *ngIf="loading">
		<svg class="spinner" width="38" height="38" viewBox="0 0 66 66">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<!-- Bar view -->
	<div class="tl-bars" *ngIf="!loading && view === 'bars'">
		<div class="tl-bar-row" *ngFor="let rep of reps; let i = index">

			<span class="tl-rank"
				  [class.tl-rank--gold]="i === 0"
				  [class.tl-rank--silver]="i === 1"
				  [class.tl-rank--bronze]="i === 2">{{ i + 1 }}</span>

			<span class="tl-rep-name" [title]="rep.salesmanname">{{ rep.salesmanname }}</span>

			<div class="tl-bar-track">
				<div class="tl-bar-fill" [style.width.%]="barPct(rep.sales)" [style.background]="barColor(i)"></div>
			</div>

			<div class="tl-bar-meta">
				<span class="tl-bar-sales">{{ fmt(rep.sales) }}</span>
				<span class="tl-bar-sub">
					<span [class.tl-up]="rep.yoy !== null && rep.yoy >= 0"
						  [class.tl-dn]="rep.yoy !== null && rep.yoy < 0">
						<ng-container *ngIf="rep.yoy !== null">
							<i class="material-icons">{{ rep.yoy >= 0 ? 'arrow_upward' : 'arrow_downward' }}</i>
							{{ formatPct(rep.yoy) }}
						</ng-container>
						<ng-container *ngIf="rep.yoy === null">—</ng-container>
					</span>
					· {{ rep.invoices }} inv · {{ rep.active_customers }} cust
				</span>
			</div>
		</div>

		<div class="tl-empty" *ngIf="!reps.length">No sales activity for this period.</div>
	</div>

	<!-- Table view -->
	<div class="tl-table-wrap" *ngIf="!loading && view === 'table'">
		<table class="tl-table">
			<thead>
				<tr>
					<th>#</th>
					<th>Rep</th>
					<th class="text-right">Sales</th>
					<th class="text-right">Units</th>
					<th class="text-right">Inv</th>
					<th class="text-right">Custs</th>
					<th class="text-right">YoY</th>
					<th class="text-right" *ngIf="!limited">Share</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let rep of reps; let i = index">
					<td class="tl-td-rank">{{ i + 1 }}</td>
					<td class="tl-td-name">{{ rep.salesmanname }}</td>
					<td class="text-right tl-td-sales">{{ rep.sales | currency:'CAD':'symbol-narrow':'1.0-0' }}</td>
					<td class="text-right">{{ rep.units | number:'1.0-0' }}</td>
					<td class="text-right">{{ rep.invoices }}</td>
					<td class="text-right">{{ rep.active_customers }}</td>
					<td class="text-right"
						[class.tl-up]="rep.yoy !== null && rep.yoy >= 0"
						[class.tl-dn]="rep.yoy !== null && rep.yoy < 0">
						{{ formatPct(rep.yoy) }}
					</td>
					<td class="text-right" *ngIf="!limited">{{ (barPct(rep.sales)) | number:'1.0-1' }}%</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
